import React, { useState } from 'react';
import MapView from '../components/MapView';
import LoginModal from '../components/LoginModal';
import RequestAccessModal from '../components/RequestAccessModal';
import AboutModal from '../components/AboutModal';
import Footer from '../components/Footer';
import './LandingPage.css';

const LandingPage = () => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRequestAccessModalOpen, setIsRequestAccessModalOpen] = useState(false);
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false);

  return (
    <div className="landing-page">
      <header className="landing-header">
        <div className="landing-header-left">
          <h1>Where's Junior</h1>
          <img src="/assets/jr-logo.svg" alt="Where's Junior" className="landing-header-logo" />
        </div>
        <div className="header-buttons">
          <button
            className="about-button"
            onClick={() => setIsAboutModalOpen(true)}
          >
              About
          </button>
          <button 
            className="request-access-button"
            onClick={() => setIsRequestAccessModalOpen(true)}
          >
            Request Access
          </button>
          <button 
            className="login-button-header"
            onClick={() => setIsLoginModalOpen(true)}
          >
            Login
          </button>
        </div>
      </header>
      
      <div className="landing-content">
        <div className="intro-text">
          <p>
            Junior Stones are placed around the world to remember Jeffrey Lucas Gurmendi Marshall and keep his 
            spirit present in meaningful places.{' '}
            <button 
              className="inline-link-button"
              onClick={() => setIsRequestAccessModalOpen(true)}
            >
              Request Access
            </button>{' '}
            to see precise locations and share your own memories.
          </p>
        </div>
        
        <MapView showPreciseLocations={false} isAuthenticated={false} />
      </div>
      
      <LoginModal 
        isOpen={isLoginModalOpen} 
        onClose={() => setIsLoginModalOpen(false)}
        onOpenRequestAccess={() => setIsRequestAccessModalOpen(true)}
      />
      
      <RequestAccessModal 
        isOpen={isRequestAccessModalOpen} 
        onClose={() => setIsRequestAccessModalOpen(false)} 
      />

      <AboutModal // Add this
        isOpen={isAboutModalOpen}
        onClose={() => setIsAboutModalOpen(false)}
      />

      <Footer />

    </div>
  );
};

export default LandingPage;